import React from 'react';
import { Select } from 'antd';
import { AsoScenarioUseSets } from '@ydistri/api-sdk';

const options = [
  { label: "Don't use", value: AsoScenarioUseSets.DontUse },
  { label: 'Min. Sets from data', value: AsoScenarioUseSets.MinSetsFromData },
  { label: 'Human Feasible Min. Sets', value: AsoScenarioUseSets.HumanFeasibleMinSets },
  { label: 'Both (From data and HFM)', value: AsoScenarioUseSets.Both },
];

interface AsoScenarioUseSetsSelectorProps {
  value: AsoScenarioUseSets;
  onChange: (value: AsoScenarioUseSets) => void;
}

const AsoScenarioUseSetsSelector: React.FC<AsoScenarioUseSetsSelectorProps> = ({
  value,
  onChange,
}) => (
  <Select<AsoScenarioUseSets>
    style={{ minWidth: 200 }}
    value={value}
    onChange={onChange}
    options={options}
  />
);

export default AsoScenarioUseSetsSelector;
